import { render } from "./Footer.vue?vue&type=template&id=2e174f36&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=2e174f36&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2e174f36"

export default script